import { render } from "./SaveEmployeeReportTo.vue?vue&type=template&id=5fff1c47"
import script from "./SaveEmployeeReportTo.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeReportTo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__